<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton>
      <template slot="bottom-right-slot" v-if="$validate.DataValid(id)">
        <template v-if="false && !isAppMode(['T01'])">
          <!-- 限制登入 -->
          <FormButton
            v-if="canBlock && !formData.login_block"
            text="blockLogin"
            color="error"
            class="ml-2"
            @click="handleBlock()"
          />
          <!-- 解除登入限制 -->
          <FormButton
            v-else-if="canBlock && formData.login_block"
            text="removeLoginBlock"
            class="ml-2"
            @click="handleRemoveBlock()"
          />
        </template>
      </template>
    </PageHeaderSlot>

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="tutorName"
                placeholder="tutorName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="category"
                placeholder="selectCategory"
                :fieldValue.sync="formData.user_type"
                :options="tutorTypeOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
                :disabled="!enableEditUserType"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="gender"
                placeholder="selectGender"
                :fieldValue.sync="formData.gender"
                :options="$genderOptions"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="phone"
                placeholder="phone"
                type="tel"
                :fieldValue.sync="formData.phone"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                isMultiple
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="remark"
                placeholder="remark"
                :fieldValue.sync="formData.remark"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" md="6" v-if="isAppMode(['T45', 'T59'])">
              <FormInput
                label="address"
                placeholder="address"
                :fieldValue.sync="formData.address"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T59'])">
              <FormDatePicker
                label="birthday"
                placeholder="birthday"
                :dateValue.sync="formData.birthday"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
                disabledActionButtons
                :maxDate="birthDateMax"
                enableInput
                pickerActive
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T45', 'T59'])">
              <FormInput
                label="idCardNumber"
                placeholder="idCardNumber"
                :fieldValue.sync="formData.hkid"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <template v-if="isAppMode(['T59'])">
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormInput
                  label="maritalStatus"
                  placeholder="maritalStatus"
                  :fieldValue.sync="formData.marital_status"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormInput
                  label="payingBank"
                  placeholder="payingBank"
                  :fieldValue.sync="formData.paying_bank"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormInput
                  label="bankAccount"
                  placeholder="bankAccount"
                  :fieldValue.sync="formData.bank_account"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormDatePicker
                  label="employmentDate"
                  placeholder="employmentDate"
                  :dateValue.sync="formData.employment_date"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                  disabledActionButtons
                  :separator="isAppMode(['T21']) ? '/' : '-'"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormInput
                  label="position"
                  placeholder="position"
                  :fieldValue.sync="formData.position"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                />
              </v-col>
            </template>
          </v-row>

          <v-row class="ma-0">
            <v-col
              cols="12"
              sm="6"
              :md="$validate.DataValid(id) && canEdit ? '5' : '4'"
              :lg="$validate.DataValid(id) && canEdit ? '4' : '3'"
            >
              <FormInput
                label="tutorAccount"
                placeholder="tutorAccount"
                :fieldValue.sync="formData.username"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :type="isAppMode(['T27']) ? 'email' : 'text'"
                :readonly="!canEdit"
              >
                <template slot="append-outer" v-if="$validate.DataValid(id) && canEdit">
                  <FormButton text="updatePassword" @click="handleEditPassword()" />
                </template>
              </FormInput>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="!$validate.DataValid(id)">
              <FormInput
                label="password"
                type="password"
                :fieldValue.sync="formData.password"
                :required="!$validate.DataValid(id)"
                showPwView
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0" v-if="enableSalary && !isAppMode(['T01'])">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="hourlyWage"
                :fieldValue.sync="formData.salary_per_hour"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                prefix="HK$"
                suffix="perHour"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0" v-if="enableSalary && !isAppMode(['T16'])">
            <v-col cols="12" md="6">
              <Datatable
                tableName="salaryLevel"
                :tableData="salaryTableData"
                :tableHeaders="salaryTableHeaders"
                disablePagination
                :breakpoint="0"
              >
                <template v-slot:[`item.level`]="{ item }">
                  {{ gfSalaryLevelName(item.level) }}
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <FormInput
                    type="number"
                    hideDetails
                    :fieldValue.sync="item.amount"
                    required
                    prefix="HK$"
                    suffix="perLesson"
                    :readonly="!canEdit"
                  />
                </template>
              </Datatable>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4" v-if="canEdit">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          text="delete"
          class="ml-4"
          outlined
          @click="handleDelete()"
          color="error"
        />
      </div>
    </v-form>

    <!-- Modal: 更改密碼 Dialog -->
    <FormDialog
      v-if="$validate.DataValid(id)"
      ref="passwordFormDialog"
      formRef="passwordForm"
      title="updatePassword"
      btnAlign="center"
      :maxWidth="500"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="newPassword" type="password" :fieldValue.sync="newPassword" required />
        </v-col>
        <v-col cols="12">
          <FormInput
            label="confirmNewPassword"
            type="password"
            :fieldValue.sync="confirmPassword"
            required
            :customRules="[
              v => {
                return (
                  !$validate.DataValid(v) ||
                  ($validate.DataValid(v) && v === newPassword) ||
                  $t('message.passwordNotMatch')
                )
              },
            ]"
          />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import { getUserTypeGrade } from '@/router/src/access'

export default {
  name: 'TutorDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
    FormInput,
    FormSelect,
    FormDialog,
    FormDatePicker,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
    tutorTypeOptions() {
      const vm = this
      const options = []
      const userTypeGrade = getUserTypeGrade(this.$config)
      if (this.$validate.DataValid(userTypeGrade[this.userType], true)) {
        userTypeGrade[this.userType].forEach(type => {
          if (type !== 'clerk' || (type === 'clerk' && this.isAppMode(['T46']))) {
            options.push({ value: type, text: vm.$t(`tutorType.${type}`) })
          }
        })
      }

      if (this.initUserType) {
        const found = options.find(el => el.value === this.initUserType)
        if (!found) {
          options.push({ value: this.initUserType, text: vm.$t(`tutorType.${this.initUserType}`) })
        }
      }

      return options
    },
    birthDateMax() {
      return this.$formatter.formatDate()
    },
    // permission & setting
    canBlock() {
      return this.$validate.allowAction('blockStaff', this.userType)
    },
    canEdit() {
      // (?)下弦唔應該edit到上弦
      return !this.isAppMode(['T46']) || this.userType !== 'admin'
    },
    enableEditUserType() {
      const userTypeGrade = getUserTypeGrade(this.$config)
      if (!this.$validate.DataValid(userTypeGrade[this.userType], true)) return false
      if (this.initUserType) {
        if (!userTypeGrade[this.userType].includes(this.initUserType)) {
          return false
        }
      }
      return true
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    initUserType: '',
    formData: {
      name: '',
      user_type: '',
      username: '',
      gender: '',
      phone: '',
      schools: [],
      remark: '',
      password: '',
      salary_per_hour: '0',
      login_block: false,

      // ---- T59 ----
      address: '',
      birthday: '',
      hkid: '',
      marital_status: '',
      paying_bank: '',
      bank_account: '',
      employment_date: '',
      position: '',
    },
    newPassword: '',
    confirmPassword: '',

    tutorSchoolOptions: [],

    enableSalary: false,
    salaryTableData: [
      { level: 'a', amount: '0', hourly_wage: '0' },
      { level: 'b', amount: '0', hourly_wage: '0' },
      { level: 'c', amount: '0', hourly_wage: '0' },
      { level: 'd', amount: '0', hourly_wage: '0' },
      { level: 'e', amount: '0', hourly_wage: '0' },
    ],
    salaryTableHeaders: [
      { value: 'level', text: vm.$t('salaryLevel'), width: 80 },
      { value: 'amount', text: vm.$t('salary') },
    ],
  }),
  methods: {
    async getTutorById() {
      try {
        const data = await this.$Fetcher.GetStaffById(this.id)

        // staff只可以view所屬分校tutor
        if (this.$validate.DataValid(data.schools, true)) {
          let pass = false
          const getUserSchools = this.gfGetUserSchools()
          for (let i = 0; i < data.schools.length; i++) {
            if (getUserSchools.includes(data.schools[i])) {
              pass = true
              break
            }
          }
          if (!pass) {
            this.permissionValid = false
            throw 'message.notBelongTutorBranch'
          }
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
        this.initUserType = data.user_type

        let isAllSchool = true
        for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
          if (this.tutorSchoolOptions[i].value !== -1) {
            const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
            if (!found) {
              isAllSchool = false
              break
            }
          }
        }
        if (isAllSchool) {
          this.formData.schools.push(-1)
        }

        if (data.salary_level) {
          this.salaryTableData.forEach(item => {
            if (this.$validate.DataValid(data.salary_level[item.level])) {
              this.$set(item, 'amount', data.salary_level[item.level])
            }
          })
        }
      } catch (err) {
        if (err !== 'abort') {
          this.showAlert({
            message: err,
            returnLink: 'TutorList',
            isError: true,
          })
        }
      }
    },

    // -- (儲存)
    async save() {
      if (!this.canEdit || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      // ------------- Payload -------------
      let payload = {
        name: this.formData.name,
        user_type: this.formData.user_type,
        schools: this.formData.schools.filter(el => el !== -1),
        gender: this.formData.gender,
        username: this.formData.username,
        phone: this.formData.phone,
        remark: this.formData.remark,
      }

      if (this.enableSalary) {
        payload['salary_level'] = {}
        this.salaryTableData.forEach(item => {
          payload['salary_level'][item.level] = parseFloat(item.amount)
        })

        if (!this.isAppMode(['T01'])) {
          payload['salary_per_hour'] = this.formData.salary_per_hour ? parseFloat(this.formData.salary_per_hour) : 0
        }
      }

      if (this.isAppMode(['T45'])) {
        payload['address'] = this.formData.address || ''
        payload['hkid'] = this.formData.hkid || ''
      } else if (this.isAppMode(['T59'])) {
        payload['address'] = this.formData.address || ''
        payload['birthday'] = this.formData.birthday || ''
        payload['hkid'] = this.formData.hkid || ''
        payload['marital_status'] = this.formData.marital_status || ''
        payload['paying_bank'] = this.formData.paying_bank || ''
        payload['bank_account'] = this.formData.bank_account || ''
        payload['employment_date'] = this.formData.employment_date || ''
        payload['position'] = this.formData.position || ''
      }
      // ---------- End of payload ----------

      if (this.$validate.DataValid(this.id)) {
        // edit
        try {
          await this.$Fetcher.UpdateStaff(this.id, payload)

          // update 返而家login account嘅center
          const getUser = this.gfGetCurrentUserData()
          if (getUser.id === this.id) {
            await this.gfUpdateUserSchools(payload['schools'])
            if (payload['schools'].length > 0) {
              const selectedSchool = this.gfGetUserSelectedSchool()
              if (selectedSchool < 0 || (selectedSchool > -1 && !payload['schools'].includes(selectedSchool))) {
                await this.gfUpdateUserSelectedSchool(payload['schools'][0])
              }
            } else {
              await this.gfUpdateUserSelectedSchool(-1)
            }
          }

          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
            refresh: true,
          })
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      } else {
        // create
        payload['password'] = this.formData.password

        try {
          await this.$Fetcher.NewAccount(payload)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.createSuccess',
            type: 'success',
            redirect: 'TutorList',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (!this.canEdit || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const confirm = await this.confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DeleteStaff(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'TutorList',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // -- (限制登入)
    async handleBlock() {
      if (!this.canBlock || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ message: 'message.confirmBlock' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.BlockStaff(this.id)
          this.formData.login_block = true
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    // -- (解除登入限制)
    async handleRemoveBlock() {
      if (!this.canBlock || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ message: 'message.confirmRemoveBlock' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.RemoveStaffBlock(this.id)
          this.formData.login_block = false
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ======== 更改密碼 =======
    async handleEditPassword(newOpen = true) {
      // reset form when open
      if (newOpen) {
        if (!this.canEdit || !this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        this.newPassword = ''
        this.confirmPassword = ''
        await this.$refs.passwordFormDialog.resetForm()
      } else {
        this.$refs.passwordFormDialog.setLoading(false)
      }

      // handle form submit
      const confirm = await this.$refs.passwordFormDialog.show()
      if (confirm) {
        try {
          await this.$Fetcher.StaffChangePassword(this.id, this.newPassword)
          this.$store.dispatch('toggleSnack', {
            message: 'message.updateSuccess',
            type: 'success',
          })
          this.$refs.passwordFormDialog.hide()
        } catch (err) {
          this.showAlert({
            title: 'message.updateFail',
            message: err,
            isError: true,
          })
          this.handleEditPassword(false)
        }
      }
    },

    // ======== 分校 Options =======
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.tutorSchoolOptions = filtered.map(el => {
            return { value: el.id, text: el.name }
          })

          let disabledAll = false
          const getUserSchools = this.gfGetUserSchools()
          if (this.$validate.DataValid(this.id)) {
            // when edit，不屬於staff的分校會disabled
            this.tutorSchoolOptions = this.tutorSchoolOptions.map(el => {
              const disabled = !getUserSchools.includes(el.value)
              if (disabled) {
                disabledAll = true
              }
              return {
                ...el,
                disabled: disabled,
              }
            })
          } else {
            // When create，只會攞staff所屬嘅分校
            this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))
          }

          this.tutorSchoolOptions.unshift({
            value: -1,
            text: this.$t('allCenters'),
            disabled: disabledAll,
          })
        }
      } catch {}
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: TutorDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      this.initUserType = ''
      if (!this.isAppMode(['T01']) && this.$validate.allowAction('viewSalary', this.userType)) {
        this.enableSalary = true
      }

      await this._getTutorSchoolOptions()
      if (this.$validate.DataValid(this.id)) {
        await this.getTutorById()
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  created() {
    this.salaryTableData = []
    for (let i = 0; i < this.$salaryLevelOptions.length; i++) {
      this.salaryTableData.push({ level: this.$salaryLevelOptions[i].value, amount: '0', hourly_wage: '0' })
    }
  },

  // // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
